import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"chevron-up\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.47 25.53a.75.75 0 0 0 1.06 0l8.293-8.293a.25.25 0 0 1 .354 0l8.293 8.293a.75.75 0 1 0 1.06-1.06l-8.293-8.293a1.75 1.75 0 0 0-2.474 0L10.47 24.47a.75.75 0 0 0 0 1.06Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol